import { useEffect, useState } from 'react';
import { getDoctorsbyDeptId } from '../api/apiServices';
import LastMenu from "../ChatFlow/Lastmenu";
import { bookAppointment } from '../api/apiServices'; // Make sure to import the API function

import dep1doc1 from '../../assets/images/dr-kumar-narayanan.png';
import dep1doc2 from '../../assets/images/dr-naga-srinivaas-akondi.png';
import dep1doc3 from '../../assets/images/dr-anil-krishna.png';

import dep2doc1 from '../../assets/images/dr-g-vara-prasada-rao.png';
import dep2doc2 from '../../assets/images/dr-sandeep-c-sabnis.png';
import dep2doc3 from '../../assets/images/dr-manoj-kumar-patta.png';

import dep3doc1 from '../../assets/images/dr-hari-radhakrishna.png';
import dep3doc2 from '../../assets/images/dr-g-ranjith.png';
import dep3doc3 from '../../assets/images/dr-vikram-kishore-reddy.png';

import dep4doc1 from '../../assets/images/dr-praveen-sodavarapu.png';
import dep4doc2 from '../../assets/images/dr-chakravarty-raj-devashis.png';
import dep4doc3 from '../../assets/images/dr-v-surya-prakash-rao.png';

const departmentImages = {
  1: [dep1doc1, dep1doc2, dep1doc3],
  2: [dep2doc1, dep2doc2, dep2doc3],
  3: [dep3doc1, dep3doc2, dep3doc3],
  4: [dep4doc1, dep4doc2, dep4doc3],
};

const BookAppointment = ({ name: initialName, mobile: initialMobile}) => {
  const [selectedLocation, setSelectedLocation] = useState('');
  const [selectedDepartment, setSelectedDepartment] = useState('');
  const [showFrame, setShowFrame] = useState(false);
  const [showFrame1, setShowFrame1] = useState(false);
  const [showAppointmentForm, setShowAppointmentForm] = useState(false);
  const [doctors, setDoctors] = useState([]);
  const [currentDoctorIndex, setCurrentDoctorIndex] = useState(0);
  const [loading, setLoading] = useState(false);

   const [name, setName] = useState(initialName || "");
   const [mobile, setMobile] = useState(initialMobile || "");
  const [email, setEmail] = useState('');
  const [appointmentDate, setAppointmentDate] = useState('');
  const [appointmentTime, setAppointmentTime] = useState('');
  const [successMessage, setSuccessMessage] = useState('');
  const [errorMessage, setErrorMessage] = useState('');

  const validateLocation = () => {
    if (!selectedLocation) {
      alert('Please select a location');
      return false;
    }
    return true;
  };

  const validateDepartment = () => {
    if (!selectedDepartment) {
      alert('Please select a department');
      return false;
    }
    return true;
  };

  const validateAppointmentDetails = () => {
    if (!name.trim()) {
      alert('Please enter your name');
      return false;
    }
    if (mobile.length !== 10) {
      alert('Please enter a valid 10-digit mobile number');
      return false;
    }
    if (!email || !email.includes('@') || email.length > 25) {
      alert('Please enter a valid email (max 25 characters)');
      return false;
    }
    if (!appointmentDate) {
      alert('Please select a date');
      return false;
    }
    if (!appointmentTime) {
      alert('Please select a time');
      return false;
    }
    return true;
  };

  const fetchDoctors = async (deptId) => {
    setLoading(true);
    try {
      const res = await getDoctorsbyDeptId(deptId);
      const data = res.data;

      if (data.message) {
        alert(data.message);
        setDoctors([]);
        setShowFrame1(false);
      } else {
        const doctorsWithImages = data.doctors.map((doc, i) => ({
          ...doc,
          image: departmentImages[deptId]?.[i] || '',
        }));
        setDoctors(doctorsWithImages);
        setCurrentDoctorIndex(0);
        setShowFrame1(true);
      }
    } catch (err) {
      console.error('Error fetching doctors:', err);
      alert('Failed to fetch doctors. Please try again later.');
    } finally {
      setLoading(false);
    }
  };

  const handlePrevDoctor = () => {
    setCurrentDoctorIndex((prev) => (prev - 1 + doctors.length) % doctors.length);
  };

  const handleNextDoctor = () => {
    setCurrentDoctorIndex((prev) => (prev + 1) % doctors.length);
  };

  const handleBookAppointment = () => {
    setShowAppointmentForm(true);
  };

  const submitFinalAppointment = async () => {
    if (validateAppointmentDetails() && doctors[currentDoctorIndex]) {
      try {
        // Map the selected time slot to MySQL-friendly time format
        const timeMap = {
          "9AM-10AM": "09:00:00",
          "10AM-11AM": "10:00:00",
          "11AM-12PM": "11:00:00",
          "2PM-3PM": "14:00:00",
          "3PM-4PM": "15:00:00"
        };

        const appointmentData = {
          name: name.trim(),
          mobile,
          email,
          appointment_date: appointmentDate,
          appointment_time: timeMap[appointmentTime], // Convert to MySQL time format
          location_id: selectedLocation,
          department_id: selectedDepartment,
          doctor_id: doctors[currentDoctorIndex].doctor_id,
        };

        await bookAppointment(appointmentData);

        setSuccessMessage('Appointment booked successfully!');
        setErrorMessage('');
        // setShowAppointmentForm(false);
      } catch (error) {
        setErrorMessage('Failed to book appointment. Please try again.');
        setSuccessMessage('');
        console.error(error);
      }
    }
  };

  const handleDepartmentSubmit = () => {
    if (validateDepartment()) {
      fetchDoctors(Number(selectedDepartment));
    }
  };

  const currentDoctor = doctors[currentDoctorIndex];

  return (
    <>
    <>
      {/* Location Selection */}
      <div className='frame1'>
        <p>Select Location</p>
        <div style={{ textAlign: 'center' }}>
          <select
            className='input-text2'
            value={selectedLocation}
            onChange={(e) => setSelectedLocation(e.target.value)}
          >
            <option value=''>-- select location --</option>
            <option value='1'>Hitech City</option>
            <option value='2'>Srikakulam</option>
            <option value='3'>Pune</option>
            <option value='4'>Banglore</option>
          </select>
          <button
            className='detatils-button2'
            onClick={() => {
              if (validateLocation()) setShowFrame(true);
            }}
          >
            Submit
          </button>
        </div>
      </div>

      {/* Department Selection */}
      {showFrame && (
        <div className='frame1'>
          <p>Select Department</p>
          <div style={{ textAlign: 'center' }}>
            <select
              className='input-text2'
              value={selectedDepartment}
              onChange={(e) => setSelectedDepartment(e.target.value)}
            >
              <option value=''>-- select department --</option>
              <option value='1'>Cardiologists</option>
              <option value='2'>Gastrointestinal</option>
              <option value='3'>Neurology</option>
              <option value='4'>Orthopedic</option>
            </select>
            <button
              className='detatils-button2'
              onClick={handleDepartmentSubmit}
            >
              Submit
            </button>
          </div>
        </div>
      )}

      {/* Doctor Carousel */}
      {showFrame1 && doctors.length === 0 && !loading && (
        <div className="no-doctors">
          <p>No doctors found for the selected department.</p>
        </div>
      )}

      {showFrame1 && doctors.length > 0 && currentDoctor && (
        <div className="frame1 animated-frame">
          <h2 style={{ textAlign: 'center', color: '#f42227', marginTop: '-5px' }}>
            Available Doctors
          </h2>

          <div className="doctor-frame">
            <div className="image-container" style={{ position: 'relative' }}>
              <button className="arrow left" onClick={handlePrevDoctor}>❮</button>

              <img
                src={currentDoctor.image}
                alt={currentDoctor.doctor_name}
                className="doctor-imge"
              />

              <div className="description2">
                <h3>{currentDoctor.doctor_name}</h3>
                <p>Speciality: {currentDoctor.speciality}</p>
                <p>Experience: {currentDoctor.experience}</p>
              </div>

              <button className="arrow right" onClick={handleNextDoctor}>❯</button>
            </div>

            <div style={{ textAlign: 'center', marginTop: '15px' }}>
              <button
                className='detatils-button2'
                onClick={handleBookAppointment}
              >
                Book Appointment
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Appointment Form */}
      {showAppointmentForm && (
        <div className="frame1 animated-frame appointment-form" style={{ textAlign: 'center', marginTop: '30px' }}>
          <h3>Enter Appointment Details</h3>
          <div style={{ marginBottom: '10px' }}>
            <input
              type="text"
              placeholder="Enter Your Name"
              className="input-text2"
              value={name}
              onChange={(e) => setName(e.target.value)}
            />
          </div>
          <div style={{ marginBottom: '10px' }}>
            <input
              type="text"
              placeholder="Enter Mobile Number"
              className="input-text2"
              value={mobile}
              onChange={(e) => {
                const value = e.target.value.replace(/\D/g, '');
                if (value.length <= 10) setMobile(value);
              }}
            />
          </div>
          <div style={{ marginBottom: '10px' }}>
            <input
              type="email"
              placeholder="Enter Email"
              className="input-text2"
              maxLength={25}
              value={email}
              onChange={(e) => setEmail(e.target.value)}
            />
          </div>
          <div style={{ marginBottom: '10px' }}>
            <input
              type="date"
              className="input-text2"
              value={appointmentDate}
              onChange={(e) => setAppointmentDate(e.target.value)}
              min={new Date().toISOString().split('T')[0]}
            />
          </div>
          <div style={{ marginBottom: '10px' }}>
            <select
              className="input-text2"
              value={appointmentTime}
              onChange={(e) => setAppointmentTime(e.target.value)}
            >
              <option value="">-- Select Time Slot --</option>
              <option value="9AM-10AM">9AM - 10AM</option>
              <option value="10AM-11AM">10AM - 11AM</option>
              <option value="11AM-12PM">11AM - 12PM</option>
              <option value="2PM-3PM">2PM - 3PM</option>
              <option value="3PM-4PM">3PM - 4PM</option>
            </select>
          </div>
          <button
            className='detatils-button2'
            onClick={submitFinalAppointment}
          >
            Submit Appointment
          </button>
          
        </div>
      )}
      {successMessage && (
        <div className='frame1'>
            <p style={{ color: 'green', marginTop: '10px' }}>{successMessage}</p>
            </div>
          )}
          {errorMessage && (
            <div className='frame1'>
            <p style={{ color: 'red', marginTop: '10px' }}>{errorMessage}</p>
            </div>
          )}
    </>
     <LastMenu/>
     </>
  );
};

export default BookAppointment;
